import { Drawer, IconButton } from "@mui/material";
import React, { useState } from "react";
import Input from "./InputComponent";
import Select from "../UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import EditPenIcon from "../../assets/images/icons/EditPenIcon.svg";

import { Circle } from "@mui/icons-material";
import { ReactComponent as UpAngleBracket } from "../../assets/images/upVectorICon.svg";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import { ReactComponent as DownAngleBracket } from "../../assets/images/downAngleBracket.svg";
import ToggleButton from "./ToggleButtons";

const ManageTagsDrawer = ({ open, close, tagList, setTagList, groupList, setGroupList }) => {
  const [selectedGroup, setSelectedGroup] = useState("");
  const [tagName, setTagName] = useState("");
  const [groupName, setGroupName] = useState("");
  const [groupColor, setGroupColor] = useState("#FACD26"); // Default color
  const [showTagList, setShowTagList] = useState(false);
  const [ShowCreateTag, setShowCreateTag] = useState(true);
  const colorOptions = ["#FACD26", "#DE3B20", "#E57000", "#4D9F45", "#3C938E", "#3785D3", "#9761CA", "#C553B6"];

  const handleColorSelect = (color) => setGroupColor(color);

  const handleSelectGroup = (event) => {
    setSelectedGroup(event.target.value);
  };

  const handleSaveTag = (e) => {
    const filterGroup = groupList.filter((group) => group.value === selectedGroup)[0];
    console.log("saveTag", tagName, filterGroup);

    setTagList([...tagList, { tagName: tagName, groupLabel: filterGroup.label, groupId: filterGroup.groupId }]);
    setTagName("");
    setSelectedGroup("");
    setShowTagList(true);
  };

  const handleCreateGroup = (e) => {
    setGroupList([
      ...groupList,
      {
        groupId: Math.floor(Math.random() * 1000),
        value: groupName,
        label: groupName,
        color: groupColor,
        showTag: false,
      },
    ]);
    setGroupName("");
    setShowTagList(false);
  };

  const handleViewGroup = (group) => {
    const mappedGroups = groupList.map((item) => {
      if (item === group) return { ...item, showTag: !item.showTag };
      else return item;
    });

    setGroupList(mappedGroups);
  };

  const handleEditTag = (tag) => {
    setTagName(tag.tagName);
    setSelectedGroup(tag.groupLabel);
  };

  const handleTagName = (e) => {
    // Update the state when the input changes
    setTagName(e.target.value);
  };

  const handleGroupName = (e) => {
    // Update the state when the input changes
    setGroupName(e.target.value);
  };

  return (
    <Drawer anchor="right" open={open} onClose={close}>
      <div className="px-5 py-5 w-[500px]">
        {/* Manage Tags */}
        <div className="flex justify-between items-center">
          <div className="text-18 text-1D4469 font-500">Manage Tags</div>
          <ClosePopUpIcn onClick={close} className="cursor-pointer" />
        </div>
        <div className="border w-full mt-2"></div>

        {/* Create Tag */}
        {ShowCreateTag && (
          <div>
            <div className="flex gap-5 items-start w-[100%] mt-5 ">
              <div className="w-[100%]  min-w-64">
                <label className="w-full text-14 text-434852 font-400 pb-1">Tag Name</label>
                <div>
                  <Input
                    name="text"
                    placeholder="Enter Tag Name"
                    value={tagName}
                    onChange={handleTagName}
                    style={{ width: "100%", height: "35px" }} // Additional styling if needed
                  ></Input>
                </div>

                <div className="  rounded-md flex items-stretch flex-wrap gap-3 p-2 w-[100%]">
                  <div className="flex border rounded text-12 text-[#848687]"></div>
                </div>
                <div className="w-[100%]  min-w-64">
                  <label className="w-full text-14 text-434852 font-400 pb-1">Group</label>

                  <Select
                    placeholder={"Select Group "}
                    options={groupList}
                    value={selectedGroup}
                    onChange={handleSelectGroup}
                    style={{
                      width: "100%",
                      height: "35px",
                      padding: "5px",
                      color: "#AFAFAF",
                      fontSize: "12px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className=" flex justify-start items-center gap-x-4 ">
              <button className="pt-2 text-12 font-400 text-009CBF" onClick={() => setShowCreateTag(false)}>
                Create Group
              </button>
            </div>

            <div className=" flex justify-end  ">
              <div className=" flex justify items-end space-x-2 text-[#535252] text-14">
                {/* <Button type="primary" style={{ color: "#535252", height: "35px" }}>
                  CANCEL
                </Button> */}
                <Button variant="primary" onClick={() => handleSaveTag()}>
                  Save
                </Button>
              </div>
            </div>

            <div className="border w-full mt-6"></div>
          </div>
        )}

        {/* Create Group */}
        {!ShowCreateTag && (
          <div>
            <div className="flex gap-5 items-start w-[100%] mt-5 ">
              <div className="w-[100%]  min-w-64">
                <label className="w-full text-14 text-434852 font-400 pb-1">Group Name</label>
                <div>
                  <Input
                    name="text"
                    placeholder="Enter Group Name "
                    value={groupName}
                    onChange={handleGroupName}
                    style={{ width: "100%", height: "35px" }} // Additional styling if needed
                  ></Input>
                </div>

                <div className="  rounded-md flex items-stretch flex-wrap gap-3 p-2 w-[100%]">
                  <div className="flex border rounded text-12 text-[#848687]"></div>
                </div>
                <div className="w-[100%]  min-w-64">
                  <label className="w-full text-14 text-434852 font-400 pb-1">Choose Color</label>
                  <div style={{ display: "flex", marginTop: "8px", marginBottom: "4px", gap: "8px" }}>
                    {colorOptions.map((color) => (
                      <IconButton
                        key={color}
                        onClick={() => handleColorSelect(color)}
                        style={{
                          border: groupColor === color ? "1px solid #1D4469" : "",
                          padding: "2px",
                          backgroundColor: groupColor === color ? color : "",
                        }}
                      >
                        <Circle style={{ color: color }} />
                      </IconButton>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className=" flex justify-start items-center gap-x-4 ">
              <button className="pt-2 text-12 font-400 text-009CBF" onClick={() => setShowCreateTag(true)}>
                Create Tag
              </button>
            </div>

            <div className=" flex justify-end  ">
              <div className=" flex justify items-end space-x-2">
                {/* <Button type="primary" style={{ color: "#535252", height: "35px" }}>
                  CANCEL
                </Button> */}
                <Button variant="primary" onClick={() => handleCreateGroup()}>
                  Save
                </Button>
              </div>
            </div>

            <div className="border w-full mt-6"></div>
          </div>
        )}

        {/* Toggle switch  */}

        <div>
          <ToggleButton
            toggleState={showTagList}
            setToggleState={(bool) => setShowTagList(bool)}
            // className={"p-1 mt-5"}
            className={"mt-5"}
            noRounded
          />

          {/* Tag List */}
          {showTagList && (
            <div className="my-4 flex flex-wrap gap-3">
              {tagList.map((tag) => {
                return (
                  <span className=" flex min-w-fit  gap-2 border py-1 px-5 text-[#383838] border-[#DEEEF6] rounded-md">
                    {tag.tagName}
                    <img src={EditPenIcon} alt="Edit Tag" onClick={() => handleEditTag(tag)} />
                  </span>
                );
              })}
            </div>
          )}

          {/* Group List */}

          {!showTagList && (
            <div className="my-4 flex flex-wrap gap-3 rounded-md  ">
              {groupList.map((group, index) => (
                <div className="border  [#F1F1F1] w-full rounded-lg ">
                  <div
                    key={index}
                    className=" w-full flex items-center justify-between pl-2 text-[#383838] rounded-sm pr-[15px]"
                  >
                    <span>
                      <IconButton
                        style={{
                          padding: "5px",
                          marginRight: "",
                          // width:'10px'
                        }}
                      >
                        <Circle style={{ color: group.color, width: "20px" }} />
                      </IconButton>
                      {group.label}
                    </span>

                    {group.showTag ? (
                      <UpAngleBracket onClick={() => handleViewGroup(group)} />
                    ) : (
                      <DownAngleBracket
                        onClick={() => {
                          handleViewGroup(group);
                        }}
                      />
                    )}
                  </div>

                  {group.showTag && (
                    <div className="m-4 flex flex-wrap gap-3">
                      {tagList
                        .filter((tag) => group.groupId === tag.groupId)
                        .map((tag) => {
                          // console.log("JAG SAG", tag);
                          return (
                            <span className=" flex min-w-fit  gap-2 border rounded py-1 px-5 border-[#DEEEF6]">
                              {tag.tagName}
                              <img src={EditPenIcon} alt="Edit Tag" onClick={() => handleEditTag(tag)} />
                            </span>
                          );
                        })}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* ************  Last button option     ********************* */}
    </Drawer>
  );
};

export default ManageTagsDrawer;

{
  /* <IconButton
// key={color}
// onClick={() => handleColorSelect(color)}
style={{
  // border: folderColor === color ? "1px solid #1D4469" : "",
  padding: "3px",
//   //  backgroundColor: folderColor === color ? color : "",
}}
>
<Circle style={{ color: "red" }} />
</IconButton> */
}
